import { useNavigate } from 'react-router-dom';

import aboutSection3 from '../../../../../assets/images/about-section3.webp';
import {
  PhilosophySectionWrapper,
  PhilosophyContainer,
  PhilosophyLeftColumn,
  PhilosophyImage,
  PhilosophyRightColumn,
  SectionHeading,
  SectionSubtext,
  PhilosophyTextContainer,
  PhilosophyText,
  PhilosophyCaptionText,
} from './styles';
import { JourneyButton, JourneyButtonContainer } from '../StorySection/styles';

const PhilosophySection = () => {
  const navigate = useNavigate();

  const handleExploreServicesClick = () => {
    navigate('/services');
  };

  return (
    <PhilosophySectionWrapper>
      <SectionHeading>The Nirva Philosophy</SectionHeading>
      <SectionSubtext>
        {
          "Nirva is more than a name—it's a living philosophy. \nIt embodies the profound yet simple transformation that occurs when we see\nthe mind with beginner's eyes."
        }
      </SectionSubtext>
      <PhilosophyContainer>
        <PhilosophyRightColumn>
          <PhilosophyImage alt="Calm woman with landscape silhouette" src={aboutSection3} />
        </PhilosophyRightColumn>
        <PhilosophyLeftColumn>
          <PhilosophyTextContainer>
            <PhilosophyText>
              {'Drawing from Zen, Yoga, A Course in\nMiracles, and modern clinical hypnotherapy.'}
            </PhilosophyText>
            <PhilosophyText>
              {'Nirva bridges science and soul to restore\nbalance between mind, body, and being.'}
            </PhilosophyText>
            <PhilosophyText>
              {
                'Through Nirva – Interpersonal Hypnotherapy\nClinic (IHC), IAIH-trained practitioners guide\nclients from confusion to clarity through\nethical, relational care.'
              }
            </PhilosophyText>
            <PhilosophyText>
              {
                "Each session becomes a practice of\nreturning—out of tension and into presence—\nuntil peace becomes the mind's natural state."
              }
            </PhilosophyText>
          </PhilosophyTextContainer>
        </PhilosophyLeftColumn>
      </PhilosophyContainer>
      <PhilosophyCaptionText>
        {
          'Nirva is both the reward of the journey and the promise it fulfills —\na peaceful mind as the true currency of life.'
        }
      </PhilosophyCaptionText>
      <JourneyButtonContainer>
        <JourneyButton variant="contained" onClick={handleExploreServicesClick}>
          Explore Our Services
        </JourneyButton>
      </JourneyButtonContainer>
    </PhilosophySectionWrapper>
  );
};

export default PhilosophySection;
